import { Box, SvgIcon, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface IPortfoliosProgressItemProps {
    coord: { x: number, y: number};
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string | undefined;}>;
    title: string;
    value: string;
    align: 'start' | 'center' | 'end';
    animationDelay?: string;
}

const width = 160;
const height = 141.72

const PortfoliosProgressItem: React.FC<IPortfoliosProgressItemProps> = ({ coord, icon, title, value, align, animationDelay }) => {
    const theme = useTheme();
    const textAlign = align === 'end' ? 'right' : (align === "start" ? 'left' : align);
    const coordX = align === 'end' ? coord.x-width : (align === "start" ? coord.x : coord.x-width/2);
    return (
        <foreignObject x={coordX} y={coord.y} width={width} height={height} className='fadein-content' style={{ animationDelay: animationDelay? animationDelay : "0s", opacity: 0}}>
            <Box display={'flex'} flexDirection={"column"} alignItems={align} gap={"16px"}>
                <Box display={"flex"} width={"53.71px"} height={"50.83px"} bgcolor={theme.palette.common.white} borderRadius={"8px"} alignItems={"center"} justifyContent={"center"}>
                <SvgIcon component={icon} sx={{ color: theme.palette.primary.dark, width: "20px", height: "20px" }} inheritViewBox />
                    {/* <img src={icon} width={"20"} height={"20"} /> */}
                </Box>
                <Typography textAlign={textAlign} fontSize={"14px"} fontWeight={"400"} lineHeight={"17.07px"}>{title}</Typography>
                <Typography textAlign={textAlign} fontSize={"20px"} fontWeight={"800"} lineHeight={"24.38px"}>{value}</Typography>
            </Box>
        </foreignObject>
    );
}

export default PortfoliosProgressItem;